import { render, staticRenderFns } from "./CreateNewAgency.vue?vue&type=template&id=51084de6"
import script from "./CreateNewAgency.vue?vue&type=script&lang=ts"
export * from "./CreateNewAgency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports